import { useParams } from 'react-router-dom';
import { useBookings } from '../../shared/booking/BookingsContext';
import BookingDetailsPage from '../../shared/booking/BookingDetailsPage';
import { cancellationLines, transferRefund } from './data';
import TransferSummary from './TransferSummary';
import TransferRide from './TransferRide';

export default function TransferBookingDetails() {
  const { bookingId } = useParams();
  const { getBooking } = useBookings();
  const booking = getBooking(bookingId);
  // Live cabs are cancelled with the operator from the ride panel.
  const live = Boolean(booking?.supplierBookingId);
  const rules = booking?.summary?.cancellation || [];

  return (
    <BookingDetailsPage
      module="transfers"
      Summary={TransferSummary}
      refLabel="Cab booking ID"
      refund={transferRefund}
      allowCancel={!live}
      extraDetails={live && <TransferRide booking={booking} allowCancel={booking.status !== 'cancelled'} />}
      policy={live ? [
        ...cancellationLines(rules),
        'Refunds go to your original payment method within 5–7 working days; the convenience fee is not refunded.',
        'Extra stops, route changes or waiting beyond the free time are charged by the operator.',
      ] : [
        'Free cancellation up to 24 hours before pickup.',
        'Cancellations within 24 hours of pickup are non-refundable.',
        'No-shows are non-refundable.',
      ]}
    />
  );
}
